import {FormatInterface} from './FormatInterface';
import {NumberFormatter} from './NumberFormatter';
import {Format} from './Format';

export class IntegerFormatter extends NumberFormatter{
	constructor(format: FormatInterface, unit: string = null) {
		format = Format.copy(format);
		format.numbers.isDecimal = false;

		super(format, unit);
	}
}
